import React, { useEffect, useState, useRef } from "react"
import { useNavigate } from "react-router-dom"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { Search } from "@mui/icons-material"
// Styles
import {
   Container,
   Backdrop,
   StyledLink,
   SearchContainer,
   Input,
} from "./MobileDrawer.styles"

const MobileDrawer = ({ searched, open, onClose }) => {
   const initial = useRef(true)
   const { t } = useTranslation()
   const navigate = useNavigate()

   const [search, setSearch] = useState(searched)

   useEffect(() => {
      if (initial.current || !search || search.trim() === "") {
         initial.current = false
         return
      }
      const timer = setTimeout(() => {
         navigate(`/search/${search}`)
      }, 1000)
      return () => clearTimeout(timer)
   }, [search, navigate])

   return (
      <>
         <Backdrop open={open} onClick={onClose} />
         <Container open={open}>
            <SearchContainer>
               <Input
                  placeholder={searched ? searched : t("navbar.input.i1")}
                  onChange={(e) => setSearch(e.target.value)}
               />
               <Search style={{ cursor: "pointer" }} />
            </SearchContainer>
            <StyledLink to="/products/optical" onClick={onClose}>
               {t("navbar.menu.m1")}
            </StyledLink>
            <StyledLink to="/products/sun" onClick={onClose}>
               {t("navbar.menu.m2")}
            </StyledLink>
            <StyledLink to="/products/accessory" onClick={onClose}>
               {t("navbar.menu.m7")}
            </StyledLink>
            <StyledLink to="/story" onClick={onClose}>
               {t("navbar.menu.m3")}
            </StyledLink>
            <StyledLink to="/mif" onClick={onClose}>
               {t("navbar.menu.m4")}
            </StyledLink>
            <StyledLink to="/new-collection" onClick={onClose}>
               {t("navbar.menu.m6")}
            </StyledLink>
            <StyledLink to="/shopfinder" onClick={onClose}>
               {t("navbar.menu.m5")}
            </StyledLink>
            <StyledLink to="/account" onClick={onClose}>
               {t("footer.menu.m4")}
            </StyledLink>
            <StyledLink to="/contact" onClick={onClose}>
               {t("footer.menu.m6")}
            </StyledLink>
         </Container>
      </>
   )
}

MobileDrawer.propTypes = {
   open: PropTypes.bool,
   onClose: PropTypes.func,
}

export default MobileDrawer
